var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuarantorInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6669 9.99996H39.5202C38.4002 6.90663 35.4669 4.66663 32.0002 4.66663C28.5336 4.66663 25.6002 6.90663 24.4802 9.99996H13.3336C10.4002 9.99996 8.00024 12.4 8.00024 15.3333V52.6666C8.00024 55.5999 10.4002 57.9999 13.3336 57.9999H50.6669C53.6002 57.9999 56.0002 55.5999 56.0002 52.6666V15.3333C56.0002 12.4 53.6002 9.99996 50.6669 9.99996ZM32.0002 9.33329C32.5869 9.33329 33.0936 9.59996 33.4669 9.99996C33.7869 10.3466 34.0002 10.8266 34.0002 11.3333C34.0002 12.4266 33.0936 13.3333 32.0002 13.3333C30.9069 13.3333 30.0002 12.4266 30.0002 11.3333C30.0002 10.8266 30.2136 10.3466 30.5336 9.99996C30.9069 9.59996 31.4136 9.33329 32.0002 9.33329ZM50.6669 52.6666H13.3336V15.3333H50.6669V52.6666ZM32.0002 18C27.6002 18 24.0002 21.6 24.0002 26C24.0002 30.4 27.6002 34 32.0002 34C36.4002 34 40.0002 30.4 40.0002 26C40.0002 21.6 36.4002 18 32.0002 18ZM32.0002 28.6666C30.5336 28.6666 29.3336 27.4666 29.3336 26C29.3336 24.5333 30.5336 23.3333 32.0002 23.3333C33.4669 23.3333 34.6669 24.5333 34.6669 26C34.6669 27.4666 33.4669 28.6666 32.0002 28.6666ZM16.0002 45.9199V49.9999H48.0002V45.9199C48.0002 39.2533 37.4136 36.3733 32.0002 36.3733C26.5869 36.3733 16.0002 39.2266 16.0002 45.9199ZM22.1602 44.6666C24.0002 43.1733 28.5069 41.68 32.0002 41.68C35.4936 41.68 40.0269 43.1733 41.8402 44.6666H22.1602Z",
    fill: "#733FE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantorInfo);
export default __webpack_public_path__ + "static/media/guarantor-info.128375b5.svg";
export { ForwardRef as ReactComponent };